import React from 'react'
import Link from 'gatsby-link'
import styled from "react-emotion"
import Img from "gatsby-image";
import ImageContainer from "../components/common/ImageContainer";
import PageContainer from "../components/common/PageContainer";
import PageTitle from "../components/common/PageTitle";
import Footer from "../components/Footer";

const PageBody = styled.div`
  color: #ffffff;
  width: 90%;
  align-self: center;
  font-family: inherit;
  
  & p {
    margin-bottom: .75rem;
  }

  @media (min-width: 960px) {
    & {
      width: 80%;
    }
    & p {
      font-size: 1.2rem;
      line-height: 1.5;
      margin-bottom: 1.2rem;
    }
  }
`

const BottomSection = styled.div`
  display: flex;
  flex-direction: column;
  align-content: stretch;
  color: #ffffff;
  

  & a {
    color: #e3cf34;
    text-decoration: none;
    background-color: rgba(34,34,34,.7);
    border: 1px solid #333333;
    border-radius: 10px;
    padding: 15px;
    margin: 10px 10px 0 10px;
    text-align: center;
    position: relative;

    &:hover {
      background-color: rgba(51,51,51,.7);
    }

    & p {
      margin-bottom: .25rem;
      line-height: 1;
      font-size: .6rem;
      text-transform: uppercase;
    }

    & h3 {
      margin-bottom: 0;
    }

    &:after {
      content: "\\e713";
      font-family: "captainicon";
      position: absolute;
      right: 20px;
      bottom: 50%;
      transform: translateY(50%);
    }
  }
  @media (min-width: 768px) {
    & {
      flex-direction: row;
      justify-content: space-around;
      flex-wrap: wrap;
      margin-top: 3rem;
    }

    & a {

      &:first-child {
        width: 95%;
        margin-bottom: 2rem;
      }

      margin: 0;
      width: 45%;
  
      &:hover {
        background-color: rgba(51,51,51,.7);
      }
  
      & h3 {
        margin-bottom: 0;
        font-size: 1.1rem;
      }
    }
  }

  @media (min-width: 960px) {
    & {
      flex-direction: row;
      justify-content: space-around;
      margin-top: 3rem;
    }

    & a {
      width: 30%;
      &:first-child {
        width: 30%;
        margin-bottom: 0;
      }
      & h3 {
        font-size: 1.2rem;
      }
    }
  }
`
const Logo = styled.div`
  font-size: 9rem;
  text-align: center;
  color: #e3cf34;
  margin-bottom: 2rem;

  @media (min-width: 768px) {
    font-size: 10rem;
  }
`


const logProps = (props) => { console.log(props.data); return null }

const IndexPage = (props) => (
  <PageContainer>
    {props.data ?
      <ImageContainer>
        <Img resolutions={props.data.headingImage.resolutions} />
      </ImageContainer>
    : null }
    <Logo>
      <i className="icon-211" />
    </Logo>
    <PageTitle>
      The Hitchhiker's Guide to Javascript
    </PageTitle>
    <PageBody>
      <p>In the beginning JavaScript was created.</p>
      <p>This has made a lot of people very angry and been widely regarded as a bad move.</p>
    </PageBody>
    { props.data ? 
      <BottomSection>
      <Link to={`/introduction/`}>
        <p>Get Started</p>
        <h3>
          Introduction
        </h3>
      </Link>
      <Link to={`/${props.data.latestPage.edges[0].node.chapter.slug}/${props.data.latestPage.edges[0].node.path}/`}>
          <p>Latest Page</p>
          <h3>
            {props.data.latestPage.edges[0].node.title}
          </h3>
        </Link>
        <Link to="/table-of-contents">
          <p>All Chapters</p>
          <h3>Table of Contents</h3>
        </Link>
      </BottomSection>
    : null }
    <Footer chapter />
  </PageContainer>
)

export default IndexPage

export const pageQuery = graphql`
query HomePageQuery {
  latestPage: allContentfulPage(sort: { fields: [createdAt], order: DESC }, limit: 1) {
    edges {
      node {
        title
        path
        chapter {
          slug
        }
      }
    }
  }
  firstChapter: allContentfulChapter(filter:{ chapterNumber: { eq: 1 } }) {
    edges{
      node {
        id
        slug        
      }
    }
  }
  headingImage: contentfulAsset(title:{ eq: "clarisse-meyer-122804"}) {
    file {
      url
    },
    resolutions(width:1920, height:1080, quality: 60) {
      ...GatsbyContentfulResolutions
    }
  }
}
`


// WEBPACK FOOTER //
// ./src/pages/index.js